<template>
  <div class="rich-editor">
    <div class="rich-toolbar">
      <button type="button" title="加粗" @mousedown.prevent="cmd('bold')"><b>B</b></button>
      <button type="button" title="斜体" @mousedown.prevent="cmd('italic')"><i>I</i></button>
      <button type="button" title="下划线" @mousedown.prevent="cmd('underline')"><u>U</u></button>
      <button type="button" title="删除线" @mousedown.prevent="cmd('strikeThrough')"><s>S</s></button>
      <span class="sep"></span>
      <button type="button" title="标题" @mousedown.prevent="cmd('formatBlock', 'H2')">H2</button>
      <button type="button" title="标题" @mousedown.prevent="cmd('formatBlock', 'H3')">H3</button>
      <button type="button" title="正文" @mousedown.prevent="cmd('formatBlock', 'P')">正文</button>
      <span class="sep"></span>
      <button type="button" title="有序列表" @mousedown.prevent="cmd('insertOrderedList')">1.</button>
      <button type="button" title="无序列表" @mousedown.prevent="cmd('insertUnorderedList')">•</button>
      <span class="sep"></span>
      <button type="button" title="左对齐" @mousedown.prevent="cmd('justifyLeft')">⬅</button>
      <button type="button" title="居中" @mousedown.prevent="cmd('justifyCenter')">⬌</button>
      <button type="button" title="右对齐" @mousedown.prevent="cmd('justifyRight')">➡</button>
      <span class="sep"></span>
      <button type="button" title="文字颜色" @mousedown.prevent="pickColor">
        <span style="color:#e6342f;">A</span>
      </button>
      <button type="button" title="插入链接" @mousedown.prevent="insertLink">🔗</button>
      <!-- 图片上传: 使用 el-upload, 沿用项目成熟的 multipart 上传方式 -->
      <el-upload
        class="rich-upload"
        :action="uploadUrl"
        :headers="uploadHeaders"
        :show-file-list="false"
        :on-success="onImageUploaded"
        :before-upload="beforeImageUpload"
        accept="image/*"
      >
        <button type="button" title="插入图片" @mousedown="saveRange">🖼</button>
      </el-upload>
      <button type="button" title="清除格式" @mousedown.prevent="cmd('removeFormat')">⌫</button>
      <input ref="colorInput" type="color" class="hidden-input" @input="applyColor" />
    </div>
    <div
      ref="editor"
      class="rich-content"
      contenteditable="true"
      :data-placeholder="placeholder"
      @input="onInput"
      @blur="onInput"
    ></div>
  </div>
</template>

<script>
import { Session } from '@/utils/storage';

export default {
  name: 'RichEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    }
  },
  data() {
    return {
      savedRange: null,
      uploadUrl: '',
      uploadHeaders: {}
    };
  },
  watch: {
    value(val) {
      // 外部赋值(如编辑回显)时同步, 避免覆盖正在输入的内容
      if (this.$refs.editor && val !== this.$refs.editor.innerHTML) {
        this.$refs.editor.innerHTML = val || '';
      }
    }
  },
  created() {
    const token = Session.get('token');
    this.uploadUrl = (process.env.VUE_APP_BASE_API || '').replace(/\/$/, '') + '/admin/upload/cover?token=' + token;
  },
  mounted() {
    this.$refs.editor.innerHTML = this.value || '';
  },
  methods: {
    onInput() {
      this.$emit('input', this.$refs.editor.innerHTML);
    },
    saveRange() {
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0);
        // 仅保存编辑器内部的选区
        if (this.$refs.editor.contains(range.commonAncestorContainer)) {
          this.savedRange = range;
        }
      }
    },
    restoreRange() {
      this.$refs.editor.focus();
      if (this.savedRange) {
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(this.savedRange);
      }
    },
    cmd(command, value = null) {
      this.$refs.editor.focus();
      document.execCommand(command, false, value);
      this.onInput();
    },
    pickColor() {
      this.saveRange();
      this.$refs.colorInput.click();
    },
    applyColor(e) {
      this.restoreRange();
      document.execCommand('foreColor', false, e.target.value);
      this.onInput();
    },
    insertLink() {
      this.saveRange();
      const url = window.prompt('请输入链接地址', 'https://');
      if (!url) return;
      this.restoreRange();
      document.execCommand('createLink', false, url);
      this.onInput();
    },
    beforeImageUpload(file) {
      const isImage = file.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能插入图片');
        return false;
      }
      return true;
    },
    onImageUploaded(response) {
      if (response.code === 0) {
        const rel = response.data && response.data.url ? response.data.url : response.data;
        const base = (process.env.VUE_APP_BASE_API || '').replace(/\/$/, '');
        const full = /^https?:\/\//.test(rel) ? rel : base + (rel.startsWith('/') ? rel : '/' + rel);
        this.restoreRange();
        document.execCommand('insertImage', false, full);
        this.onInput();
      } else {
        this.$message.error(response.msg || '图片上传失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rich-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}
.rich-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 6px 8px;
  background: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
  button {
    min-width: 30px;
    height: 28px;
    margin: 2px;
    padding: 0 6px;
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 3px;
    cursor: pointer;
    font-size: 13px;
    line-height: 1;
    &:hover {
      border-color: #409eff;
      color: #409eff;
    }
  }
  .rich-upload {
    display: inline-block;
    line-height: 1;
  }
  .sep {
    width: 1px;
    height: 18px;
    background: #dcdfe6;
    margin: 0 6px;
  }
  .hidden-input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
  }
}
.rich-content {
  min-height: 240px;
  max-height: 520px;
  overflow-y: auto;
  padding: 12px;
  font-size: 14px;
  line-height: 1.7;
  outline: none;
  &:empty::before {
    content: attr(data-placeholder);
    color: #c0c4cc;
  }
  ::v-deep img {
    max-width: 100%;
  }
}
</style>
